// The page the user lands on after opening the app and without a session
export const FirstRunPage = 'TutorialPage';

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const WelcomePage = 'WelcomePage';
export const MainPage = 'TabsPage';


// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'HomePage';
export const Tab2Root = 'FriendsPage';
export const Tab3Root = 'ConversationsPage';
export const Tab4Root = 'NotificationsPage';
export const Tab5Root = 'ProfilePage';



// WEBPACK FOOTER //
// ./src/pages/pages.ts